import { render, staticRenderFns } from "./settlement_yukon.vue?vue&type=template&id=657e801c&"
import script from "./settlement_yukon.vue?vue&type=script&lang=js&"
export * from "./settlement_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports